export class ReportSchedulesListService {
  static $inject = ['$q', 'ModeCollection', 'ReportSubscriptionModel', 'ReportScheduleModel'];

  constructor(
    private $q,
    private ModeCollection: any,
    private ReportSubscriptionModel: any,
    private ReportScheduleModel: any
  ) {}

  public includeScheduleCreatorsAndSubscriptions(schedules) {
    if (schedules) {
      return this.includeSubscriptions(schedules).then((schedulesWithSubscriptions) =>
        this.includeCreators(schedulesWithSubscriptions).then(
          (schedulesWithSubscriptionsAndCreators) => schedulesWithSubscriptionsAndCreators
        )
      );
    }
  }

  includeSubscriptions(schedules) {
    return this.$q.all(
      schedules.map((schedule) =>
        schedule.savedSubscriptions
          ? schedule
          : schedule
              .reportSubscriptions({ useEntryPath: true })
              .then(this.ModeCollection.elements)
              .then((reportSubscriptions) =>
                this.ReportSubscriptionModel.buildSubscriptionWithSlackMembership(reportSubscriptions).then(
                  (subscriptionsWithSlackMemberships) => {
                    schedule.savedSubscriptions = subscriptionsWithSlackMemberships;
                    return schedule;
                  }
                )
              )
      )
    );
  }

  includeCreators(schedules) {
    return this.ReportScheduleModel.buildSchedulesWithCreators(schedules).then(
      (schedulesWithCreators) => schedulesWithCreators
    );
  }
}
